/* eslint-disable quotes */
import { LOCALE } from '@/utils'
import type { Locale } from '@/schema'

// All JSONLD availables
import { jsonLdHomepage } from './jsonld/homepage'
import { jsonLdGallery } from './jsonld/gallery'
import { jsonLdFaqs } from './jsonld/faqs'
import { jsonLdLogin } from './jsonld/login'
import { jsonLdSignup } from './jsonld/signup'

const jsonLdByType = {
  'home': (data, locale) => jsonLdHomepage(data, locale),
  'gallery': (data, locale) => jsonLdGallery(data, locale),
  'faqs': (data, locale) => jsonLdFaqs(data, locale),
  'login': (data, locale) => jsonLdLogin(data, locale),
  'signup': (data, locale) => jsonLdSignup(data, locale)
}

type TypeGetJsonld = {
  type: keyof typeof jsonLdByType,
  data?: {
    [key:string]: any
  },
  locale?: Locale
}

export const getJsonld = ({ type, data = null, locale = LOCALE as Locale }:TypeGetJsonld) => jsonLdByType[type](data, locale)

